<template>
  <CRow>
    <CCol sm="12">
      <CCard>

        <CCardHeader>
          <CIcon name="cil-group" />
          <h5 class="d-inline ml-2">MenutePay Users</h5>
          <div class="card-header-actions">
            <CButton v-if="companyId" color="link" :to="{name: 'View Company', params: {'id': companyId}}" class="ml-2">
              <CIcon name="cil-arrow-thick-left" class="align-bottom" /> Back To Company
            </CButton>
          </div>
        </CCardHeader>

        <BackendTable />
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import BackendTable from "./BackendTable";

export default {
  name: "MenutePayUsers",
  components: {
    BackendTable,
  },
  computed: {
    companyId() { return this.$route.params.company_id; },
  },
};
</script>
